module.exports = __webpack_public_path__ + "static/2-21e13d5acb9a4cf169f18de8dfb239f4.jpg";